module.exports = __webpack_public_path__ + "static/media/Grid.a5b394f4.svg";